/**
 * Same-tab signal that the user just changed what is read (for example "Mark all as read" in the Inbox),
 * so the bell refreshes at once instead of waiting for the broadcast. LiveNotifications listens for it.
 */
export const BELL_REFRESH_EVENT = 'edverum:bell-refresh';

export function requestBellRefresh() {
    window.dispatchEvent(new CustomEvent(BELL_REFRESH_EVENT));
}
